/* Carpe Ice: zoekveld in de header (desktop vanaf 1180px).
   Zoeken zelf doet het <predictive-search>-component van het thema (gekoppeld via aria-owns op het formulier).
   Dit script regelt alleen open/dicht: het zet het open-attribuut op het zoekveld. CSS toont dan het paneel, en de
   bestaande themaregel voor [open] in de header maakt een transparante header vast. */
(() => {
  const item = document.querySelector('.ci-search-pill-item');
  const panel = document.getElementById('ci-search-panel');
  if (!item || !panel) return;

  const inside = (el) => el instanceof Node && (item.contains(el) || panel.contains(el));
  const close = () => item.removeAttribute('open');

  item.addEventListener('focusin', () => item.setAttribute('open', ''));
  // Klik of tik buiten zoekveld en paneel (ook op de donkere laag) sluit het paneel.
  document.addEventListener('pointerdown', (event) => { if (!inside(event.target)) close(); });
  // Met Tab weglopen uit zoekveld en paneel sluit het ook.
  document.addEventListener('focusout', (event) => { if (event.relatedTarget && !inside(event.relatedTarget)) close(); });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && item.hasAttribute('open')) {
      close();
      document.activeElement?.blur();
    }
  });
})();
